"use client";
import { useActionsTrack } from "@/_old/features/analytics";
import { Button } from "@/core/components/ui/button";
import { FileText } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ExportInsightsConfirmDialog } from "./components/export-insights-confirm-dialog";
import { ExportInsightsGeneratingDialog } from "./components/export-insights-generating-dialog";
import { ReportViewer } from "./components/report-viewer";
import { useReportRequest } from "./hooks/useReportRequest";
import { ReportData, ReportExportButtonProps } from "./types";

export function ActionExportReportInsights({
  filters,
}: ReportExportButtonProps) {
  const [showConfirm, setShowConfirm] = useState(false);
  const [showReport, setShowReport] = useState(false);
  const { isGenerating, progress, currentStep, data, start, reset } =
    useReportRequest(filters);
  const [translate] = useTranslation(["dashboard"]);
  const { onActionClick } = useActionsTrack();

  const handleExportClick = () => {
    onActionClick("INSIGHTS_EXPORT_REPORT", "DASHBOARD");
    setShowConfirm(true);
  };

  const handleConfirm = async () => {
    onActionClick("INSIGHTS_EXPORT_REPORT_CONFIRM", "DASHBOARD");
    setShowConfirm(false);
    await start();
    if (data || true) {
      setShowReport(true);
    }
  };

  const handleCloseReport = () => {
    onActionClick("INSIGHTS_EXPORT_REPORT_CLOSE", "DASHBOARD");
    setShowReport(false);
    reset();
  };

  const shouldShowViewer = !isGenerating && !!data && !showReport;
  if (shouldShowViewer) {
    setShowReport(true);
  }

  if (showReport && data) {
    return (
      <ReportViewer
        filters={filters}
        onClose={handleCloseReport}
        reportData={data as ReportData}
      />
    );
  }

  return (
    <>
      <Button
        onClick={handleExportClick}
        variant="primary"
        size="lg"
        className="gap-2"
      >
        <FileText className="w-4 h-4" />
        {translate("dashboard-export-report-insights-button-label")}
      </Button>

      <ExportInsightsConfirmDialog
        open={showConfirm}
        onOpenChange={setShowConfirm}
        onConfirm={handleConfirm}
        filters={filters}
      />

      <ExportInsightsGeneratingDialog
        open={isGenerating}
        progress={progress}
        currentStep={currentStep}
      />
    </>
  );
}
